/**
 * 报表模块组件id的定义
 * 注意：后台数据库中定义了一套模块id，为了防止使用模糊化，此处的id和数据库中定义的保持一致，不可随意修改！
 */
export const REPORT = {
  TOTAL_SEND: {
    id: 1,
    name: '总发送量',
  },
  TREND_SEND: {
    id: 2,
    name: '发送趋势图',
  },
  RATIO_MSG_SEND: {
    id: 3,
    name: '各消息类型发送占比',
  },
  TOTAL_BIZTYPE_SEND: {
    id: 4,
    name: '业务类型发送量top5',
  },
  TREND_SMS_SEND: {
    id: 5,
    name: '短信发送趋势',
  },
  RATIO_SMS_CHANNEL: {
    id: 6,
    name: '短信渠道发送占比',
  },
  TOTAL_MO_SMS: {
    id: 7,
    name: '短信上行统计',
  },
  TOTAL_WECHAT_FANS: {
    id: 8,
    name: '微信粉丝',
  },
  TREND_WECHAT_INDICATOR: {
    id: 9,
    name: '微信关键指标趋势',
  },
  TREND_EMAIL_SEND: {
    id: 10,
    name: '邮件发送趋势',
  },
  TOTAL_MO_EMAIL: {
    id: 11,
    name: '邮件上行统计',
  },
  TREND_VOICE_TIME: {
    id: 12,
    name: '语音通话时长趋势图',
  },
  FUNNEL_VOICE_SEND: {
    id: 13,
    name: '语音消息发送漏斗图',
  },
  getReportNameById,
};

export const REPORT_TOKED = 'report-page-custom-token';

function getReportNameById(id) {
  let name: string;
  for (const key in REPORT) {
    if (Object.prototype.hasOwnProperty.call(REPORT, key) && !name) {
      const element = REPORT[key];
      if (element.id === id) {
        name = element.name;
      }
    }
  }
  return name;
}
